// Formatos ricos de MARKETING (oferta por tempo limitado e carrossel): tipos e a
// tradução entre os campos da tela e o formato da API. Os componentes ficam em
// components/TemplateRichFields.tsx.

export type TemplateFormat = 'standard' | 'offer' | 'carousel';
export interface OfferDraft { text: string; has_expiration: boolean }
export type CardMedia = 'image' | 'video';
export interface CardButtonShape { type: 'quick_reply' | 'url' | 'phone_number'; text: string; phone?: string }
export interface CardDraft { media_url: string; body: string; examples: string[]; urls: string[]; url_examples: string[] }

export interface SpecCard {
  header: { type: string; media_url?: string };
  body: { text: string; example?: string[] };
  buttons: { type: string; text: string; url?: string; phone?: string; example?: string }[];
}

const VAR_RE = /\{\{\s*([a-z0-9_]+)\s*\}\}/gi;
export const varNames = (text: string): string[] => {
  const out: string[] = [];
  for (const m of text.matchAll(VAR_RE)) if (!out.includes(m[1])) out.push(m[1]);
  return out;
};

export const emptyCard = (): CardDraft => ({ media_url: '', body: '', examples: [], urls: [], url_examples: [] });

/** Os cartões no formato da API. */
export function buildCards(media: CardMedia, shape: CardButtonShape[], cards: CardDraft[]): SpecCard[] {
  return cards.map((c) => ({
    header: { type: media, media_url: c.media_url },
    body: { text: c.body, example: c.examples.slice(0, varNames(c.body).length) },
    buttons: shape.map((b, i) => b.type === 'url'
      ? { type: 'url', text: b.text, url: c.urls[i] ?? '', ...(((c.urls[i] ?? '').includes('{{')) ? { example: c.url_examples[i] ?? '' } : {}) }
      : b.type === 'phone_number' ? { type: 'phone_number', text: b.text, phone: b.phone ?? '' }
        : { type: 'quick_reply', text: b.text }),
  }));
}

/** Volta dos cartões gravados para os campos (edição). */
export function cardsFromSpec(specCards: SpecCard[]): { media: CardMedia; shape: CardButtonShape[]; cards: CardDraft[] } {
  const first = specCards[0];
  const media: CardMedia = first?.header?.type === 'video' ? 'video' : 'image';
  const shape: CardButtonShape[] = (first?.buttons ?? []).map((b) => ({
    type: (b.type as CardButtonShape['type']) ?? 'quick_reply', text: b.text, phone: b.phone,
  }));
  const cards = specCards.map((c) => ({
    media_url: c.header?.media_url ?? '',
    body: c.body?.text ?? '',
    examples: c.body?.example ?? [],
    urls: (c.buttons ?? []).map((b) => b.url ?? ''),
    url_examples: (c.buttons ?? []).map((b) => b.example ?? ''),
  }));
  return { media, shape, cards };
}

